import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useApi } from '@/composables/useApi';

export const InvoiceStatuses = {
  Paid: 1,
  Open: 0,
};

export const useInvoiceStore = defineStore('invoiceStore', () => {
  const { t } = useI18n();

  const { apiGet } = useApi();

  const invoices = ref([]);
  const invoice = ref();

  async function getAndSetOrderInvoices(orderId) {
    invoices.value = await apiGet(`orders/${orderId}/invoices`) ?? [];
  }

  async function getInvoiceByID(id) {
    return apiGet(`invoices/${id}`);
  }

  function invoiceTypeName(invoice) {
    return invoice.isCreditNote
      ? t('creditNote')
      : invoice.isPrepayment
        ? t('orderDetail.prepayment')
        : t('invoice');
  }

  function invoiceTitle(invoice) {
    let title = invoiceTypeName(invoice) + ' ';

    if (invoice.invoiceNrPrefix) {
      title += invoice.invoiceNrPrefix;
    }

    title += invoice.invoiceNr;

    return title;
  }

  function getInvoiceDocument(invoice) {
    const text = invoiceTypeName(invoice);
    return {
      name: 'invoice',
      downloading: false,
      text,
      downloadName: `${text}-${invoice.invoiceNrPrefix}${invoice.invoiceNr}.pdf`,
      url: `invoices/${invoice.id}/files/${invoice.offerTypeId}?type=print`,
    };
  }

  return {
    invoice,
    invoices,
    getAndSetOrderInvoices,
    getInvoiceByID,
    invoiceTypeName,
    invoiceTitle,
    getInvoiceDocument,
  };
});
